import { useState } from 'react';
import { Box } from '@mui/material';

import Block from '../../../../../components/Block';

import { CampaignAdGroup } from '../../../../../types/Campaign';
import { useCampaignPageContext } from '../../../../../hooks/Contexts/Pages/CampaignPageContext';
import CampaignAdGroupDataGrid from '../DataGrid/CampaignAdGroupDataGrid';
import CampaignAdGroupDrawer from '../Drawer/CampaignAdGroupDrawer';

const CampaignPageAdGroupPageTab = () => {
    const { campaign } = useCampaignPageContext();

    const [activeCampaignAdGroup, setActiveCampaignAdGroup] = useState<CampaignAdGroup | undefined>(undefined);

    return (
        <Box>
            <Block>
                <CampaignAdGroupDataGrid
                    rows={campaign.adGroups}
                    action={{
                        name: 'View Details',
                        callback: (campaignAdGroup: CampaignAdGroup): void => {
                            setActiveCampaignAdGroup(campaignAdGroup);
                        },
                    }}
                />
            </Block>

            {activeCampaignAdGroup && (
                <CampaignAdGroupDrawer
                    open={!!activeCampaignAdGroup}
                    campaignAdGroup={activeCampaignAdGroup}
                    campaign={campaign}
                    onCancel={(): void => {
                        setActiveCampaignAdGroup(undefined);
                    }}
                    onSave={(): void => {
                        setActiveCampaignAdGroup(undefined);
                    }}
                />
            )}
        </Box>
    );
};

export default CampaignPageAdGroupPageTab;
